$(document).ready(function() {
  // objectFitImages();

  function lazyLoadImages() {
    const images = document.querySelectorAll('img[data-src],source[data-srcset]');

    const options = {
      root: null,
      rootMargin: '0px 0px 100px',
      threshold: 0.1
    };

    function handleIntersection(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const tagName = element.tagName.toLowerCase();

          if (tagName === 'img') {
            const src = element.dataset.src;
            element.setAttribute('src', src);
            element.removeAttribute('data-src');
          } else if (tagName === 'source') {
            const srcset = element.dataset.srcset;
            element.setAttribute('srcset', srcset);
            element.removeAttribute('data-srcset');
          }
          observer.unobserve(element);
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersection, options);

    images.forEach(img => {
      observer.observe(img);
    });
  }

  lazyLoadImages();

  //---------------------------------
  // Smooth Scrolling
  //---------------------------------

  $('a[href^="#"]').click(function() {
    var headerHight = $('header').outerHeight(true);
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "body" : href);
    var position = target.offset().top - headerHight - 50;
    $("html, body").animate({ scrollTop: position }, 600, "swing");
    return false;
  });

  // $('a[href^="#"]').click(function() {
  //   var the_id = $(this).attr("href");
  //   $('html, body').animate({
  //     scrollTop: $(the_id).offset().top - 50
  //   }, 'slow');



  $('#nav-btn').click(function() {
    $('#nav-btn').toggleClass('open');
    $('#nav').toggleClass('open');
  });

  //---------------------------------
  // トグルメニュー
  //---------------------------------

  // ページのロード時に状態を復元する
  const ele = $('.js-toggle-content');
  for (let i = 0; i < ele.length; i++) {
    if (!(ele.eq(i).hasClass('is-show'))) {
      ele.eq(i).hide();
    }
    // const key = window.location.pathname + '_' + $(ele[i]).parent('.prd_wrap').index().toString();
    // const state = localStorage.getItem(key);

    // if (state === 'true') {
    //   $(ele[i]).show();
    //   $(ele[i]).prev('.js-toggle-btn').addClass('is-open');
    // } else {
    //   $(ele[i]).hide();
    //   $(ele[i]).prev('.js-toggle-btn').removeClass('is-open');
    // }

    // if ((ele.eq(i).hasClass('is-show'))) {
    //   ele.eq(i).show();
    //   ele.eq(i).prev('.js-toggle-btn').addClass('is-open');
    // }
  }

  // クリックイベントの処理を定義
  $('.js-toggle-btn').click(function() {
    $(this).toggleClass('is-open');
    $(this).next('.js-toggle-content').slideToggle(300);

    var url = $(this).next().find('iframe').attr('src');
    var result = url.replace('?&view=embed', '');
    $(this).next().find('iframe').attr('src', result);

    // 状態をセッションストレージに保存
    // const state = $(this).hasClass('is-open');
    // const key = window.location.pathname + '_' + $(this).parent('.prd_wrap').index().toString();
    // localStorage.setItem(key, state.toString());

    // $(this).next('.js-toggle-content').find('iframe').each(function() {
    //   var src = $(this).attr('src');
    //   $(this).attr('src', src);
    // });


    return false;
  });


  //---------------------------------
  // 入居者の声のホバー処理
  //---------------------------------

  // hoverする要素のclass名
  $(".person").hover(
    function() {
      $(".person").addClass("is-hover");
      $(this).removeClass("is-hover");
    },
    function() {
      $(".person").removeClass("is-hover");
    }
  );


  //---------------------------------
  // トップのスライダー
  //---------------------------------

  if ($('.mv').length) {
    var ext_slide = $('.ext_slide').slick({
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 800,
      //   dots: true,
      arrows: true,
      variableWidth: true,
      centerMode: true,
      centerPadding: '12%',
      infinite: true,
      prevArrow: '<div class="prev"></div>',
      nextArrow: '<div class="next"></div>',
      // asNavFor: '.thumb_nav',
      waitForAnimate: false,
      //  appendArrows: $('.arrows_sub'),
      responsive: [{
        breakpoint: 1025,
        settings: {
          centerPadding: '5%',
        },
        breakpoint: 769,
        settings: {
          centerPadding: '0',
          dots: true,
          variableWidth: false,
          autoplaySpeed: 3500,
          arrows: false,
          appendDots: $('.dots'),
        },
      }]
    });

    var thumb_nav = $('.thumb_nav').slick({
      accessibility: true,
      //autoplay: true,
      //autoplaySpeed: 4000,
      speed: 500,
      //arrows: true,
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 7,
      swipe: true,
      draggable: true,
      // centerMode: true,
      // asNavFor: '.ext_slide',
      // focusOnSelect: true,
      adaptiveHeight: false,
      //appendArrows: $('.arrows_sub'),
      //prevArrow:'<div class="prev"></div>',
      //nextArrow:'<div class="next"></div>',
      responsive: [{
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      }]
    });

    $('.mv .arrows_sub .prev').on('click', function() {
      thumb_nav.slick('slickPrev')
    });

    $('.mv .arrows_sub .next').on('click', function() {
      thumb_nav.slick('slickNext')
    });

    $('.mv .thumb_nav li').on('click', function() {
      var index = $('.mv .thumb_nav li').index($(this));
      if (index >= 21) {
        index = index % 7;
        index = index + 14;
      } else if (index >= 14) {
        index = index % 7;
        index = index + 7;
      } else {
        index = index % 7;
      }
      ext_slide.slick('slickGoTo', index);
    });
  }

  //---------------------------------
  // PICK UPのスライダー
  //---------------------------------

  if ($('.slider_column').length) {
    $('.slider_column').slick({
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 800,
      dots: true,
      arrows: true,
      slidesToShow: 4,
      infinite: true,
      responsive: [{
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '13%',
          autoplaySpeed: 5500,
        },
      }]
    });
  }


  //---------------------------------
  // 防音コラムのスライダー
  //---------------------------------

  if ($('.column_slide').length) {
    $('.column_slide').slick({
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 800,
      dots: false,
      arrows: true,
      centerMode: true,
      centerPadding: '23.5%',
      infinite: true,
      prevArrow: '<div class="prev"></div>',
      nextArrow: '<div class="next"></div>',
      responsive: [{
        breakpoint: 1025,
        settings: {
          centerPadding: '5%',
        }
      }, {
        breakpoint: 769,
        settings: {
          centerPadding: '8%',
        }
      }]
    });
  }

  //---------------------------------
  // 店舗案内のスライダー
  //---------------------------------

  if ($('.post_slider').length) {
    $('.post_slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      infinite: true,
      asNavFor: '.thumb_nav'
    });
    $('.thumb_nav').slick({
      accessibility: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 400,
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      asNavFor: '.post_slider',
      focusOnSelect: true,
      adaptiveHeight: false,
      prevArrow: '<div class="prev"></div>',
      nextArrow: '<div class="next"></div>',
      responsive: [{
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        }
      }]
    });
  }


  //---------------------------------
  // モデルルーム　スライダー
  //---------------------------------

  if ($('.post_slider_ext').length) {
    $('.post_slider_ext').not('.slick-initialized').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.thumb_nav_ext'
    });
    $('.thumb_nav_ext').not('.slick-initialized').slick({
      accessibility: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 400,
      arrows: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      vertical: true,
      asNavFor: '.post_slider_ext',
      focusOnSelect: true,
      responsive: [{
        breakpoint: 769,
        settings: {
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          vertical: false,
          centerMode: true,
          centerPadding: '10%',
        }
      }]
    });
  }

  //---------------------------------
  // ハンバーガーメニュー
  //---------------------------------

  $('.hamburger').on('click', function() {
    // $('header .h_wrapper nav').stop().slideToggle('fast');
    $(this).toggleClass("active");
    $('#menu-content').slideToggle(500);
  });


  //---------------------------------
  // モーダル
  //---------------------------------

  $('#openModal').click(function() {
    $('#modalArea').fadeIn();
  });
  $('#closeModal , #modalBg').click(function() {
    $('#modalArea').fadeOut();
  });

  //--------------------------------------
  //　スクロールでフェードイン
  //--------------------------------------

  const iSObservers = document.querySelectorAll("[class*='fade']");
  const options = {
    rootMargin: '0px 0px',
  };

  const fadeUp = (target) => {
    target.classList.add('is-animated');
  };

  const observeUse = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        fadeUp(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observeUse, options);
  iSObservers.forEach(iSObserver => {
    observer.observe(iSObserver);
  });

  //--------------------------------------
  //　FAQ toggle
  //--------------------------------------

  if ($('.faq_box').length) {
    $('.faq_box dt').click(function() {
      $(this).toggleClass('is-open');
      $(this).next('dd').slideToggle(300);
      return false;
    });
  }

  //--------------------------------------
  //　ページトップへ飛ぶリンク
  //--------------------------------------
  if ($('.product-post').length) {
    const totop = $('#totop');

    totop.click(function() {
      $('html, body').animate({
        scrollTop: 0
      }, {
        duration: 1200,
        easing: 'swing',
      });
      return false;
    });

    const sec1Element = document.querySelector('.sec_1');

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          totop.removeClass('is-show');
        } else {
          totop.addClass('is-show');
        }
      });
    }, options);

    observer.observe(sec1Element);
  }

  //--------------------------------------
  //　画像モーダル
  //--------------------------------------
  if ($('[data-fancybox]').length) {
    $('[data-fancybox]').fancybox();
  }

  //--------------------------------------
  // 物件検索　タブ切り替え
  //--------------------------------------
  $('.tab').on('click', function() {
    $('.panel').removeClass('active');
    var index = $('.tab').index(this);
    $('.panel').eq(index).addClass('active');
  });

  //--------------------------------------
  //　スクロールヒント
  //--------------------------------------
  if ($('.js-scroll-hint').length) {
    new ScrollHint('.js-scroll-hint', {
      scrollHintClass: 'scroll-hint',
      scrollHintIconClass: 'scroll-hint-icon',
      enableOverflowScrolling: true,
      offset: 0,
      i18n: {
        scrollable: '横にスクロールできます'
      }
    });
  }

  //--------------------------------------
  //　フォーム
  //--------------------------------------

  $('.form_n input[name="your_kind"]:radio').on('change', function() {
    var cjk_r1 = $('.form_n input[name=your_kind]:checked').val();
    if (cjk_r1 === '内覧希望') {
      $('.switch').fadeIn('fast');
    } else {
      if (cjk_r1 === "個別相談希望") {
        $('.switch').fadeOut('fast');
      }
      if (cjk_r1 === "ご質問") {
        $('.switch').fadeOut('fast');
      }
      if (cjk_r1 === "その他") {
        $('.switch').fadeOut('fast');
      }
    }
  });

  if ($('.form_n').length) {
    var cjk_r1 = $('.form_n input[name=your_kind]:checked').val();
    if (cjk_r1 === '内覧希望') {
      $('.switch').fadeIn(0, formControl());
    } else {
      if (cjk_r1 === "個別相談希望") {
        $('.switch').fadeOut(0, formControl());
      }
      if (cjk_r1 === "ご質問") {
        $('.switch').fadeOut(0, formControl());
      }
      if (cjk_r1 === "その他") {
        $('.switch').fadeOut(0, formControl());
      }
    }
  }

  // お問い合わせ画面遷移
  function formTransition(form) {
    var ttl_position = form.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo(0, ttl_position - 100);
  }

  function formControl() {
    const error = document.querySelector('.error');
    const formConfirm = document.querySelector('.mw_wp_form_confirm');
    const formComplete = document.querySelector('.mw_wp_form_complete');
    if ($(".mw_wp_form_input").length) {
      if (error) {
        formTransition(error);
      }
    }
    if (formConfirm) {
      formTransition(formConfirm);
    }
    if (formComplete) {
      formTransition(formComplete);
    }
  }

  formControl();

  if ($('#calender').length) {
    $('#calender').datetimepicker({
      format: 'Y/m/d H時',
      minTime: '9:00',
      maxTime: '21:00'
    });
  }

  $('input[name="submitBack"]').on('click', function() {
    $('form').attr("action", "");
  });

  if ($('.cb_purpose').length) {
    $('.cb_purpose span:eq(10) label').css('width', '80px');
    $('.cb_purpose span:eq(12) label').css('cssText', 'padding-right:0!important; width:80px;');
  }
  if ($('.cb_trigger').length) {
    $('.cb_trigger span:eq(16) label').css('width', '80px');
    $('.cb_trigger span:eq(18) label').css('cssText', 'padding-right:0!important; width:80px;');
  }
  if ($('.form_n').length) {
    $('.form_n .purpose_6').insertAfter('.form_n .cb_purpose span:eq(10)');
    $('.form_n .purpose_7').insertAfter('.form_n .cb_purpose span:eq(12)');
    $('.form_n .trigger_9').insertAfter('.form_n .cb_trigger span:eq(16)');
    $('.form_n .trigger_10').insertAfter('.form_n .cb_trigger span:eq(18)');
  }

  // フォームを送信する際の処理
  function submitForm() {
    var formData = $('#search_form').serialize();
    // console.log(search_form);
    $.ajax({
      method: 'GET',
      url: '/wp-admin/admin-ajax.php?action=my_ajax_action',
      data: formData,
      success: function(response) {
        var hitCount = response;
        $('.hit .number').text(hitCount);
      },
      error: function() {
        console.log('エラーが発生しました');
      }
    });
  }

  // 物件詳細　スライダー
  if ($('.product-post').length) {
    $(window).on('load resize', function() {
      // var photoH = $("#photo>img").innerHeight();
      // $("#photo").css("height", photoH + "px");
      $("#navi .thumb_container_track").find("a:lt(1)").addClass("active");
    });

    var total_img_num = $("#navi .thumb_container_track a").length;
    total_img_num--;
    var click_flg = false;

    $("#navi .thumb_container_track a").click(function() {
      change_img(this);
      return false;
    });

    $("#photo .prev").on('click', function() {
      var lct_old = $("#navi .thumb_container_track").find("a.active").data('count');
      if (lct_old > 0) {
        lct_old--;
        var lct_new = $("#navi .thumb_container_track").find('[data-count = ' + lct_old + ']');
        change_img(lct_new);
      } else {
        lct_old = total_img_num;
        var lct_new = $("#navi .thumb_container_track").find('[data-count = ' + lct_old + ']');
        change_img(lct_new);
      }
    });

    $("#photo .next").on('click', function() {
      var lct_old = $("#navi .thumb_container_track").find("a.active").data('count');
      if (lct_old < total_img_num) {
        lct_old++;
        var lct_new = $("#navi .thumb_container_track").find('[data-count = ' + lct_old + ']');
        change_img(lct_new);
      } else {
        lct_old = 0;
        var lct_new = $("#navi .thumb_container_track").find('[data-count = ' + lct_old + ']');
        change_img(lct_new);
      }
    });

    function change_img(_this) {
      if (click_flg == false) {
        click_flg = true;
        $(_this).parents(".thumb_container_track").find('a.active').removeClass('active');
        $(_this).addClass('active');
        var thisText = $(_this).find('img').attr('alt');
        $('.photo_caption').html("<p>" + thisText + "</p>");
        $("#photo img").before("<img src='" + $(_this).attr("href") + "' alt=''>");
        $("#photo img:last").stop(true, false).fadeOut("fast", function() {
          $(this).remove();
          click_flg = false;
        });
        return false;
      } else {
        return false;
      }
    }

    var total_cont = 0;
    do {
      $(".thumb_container_track").children("a:lt(5)").wrapAll('<div class="thumb_container"></div>');
      total_cont++;
      $('<li></li>').prependTo(".thumb_ctl ul.nav_ul");
    }
    while ($(".thumb_container_track").children("a").length);
    if (total_cont > 2) {
      $(".thumb_ctl ul.nav_ul").children('li:lt(1)').addClass('active');
      $(".thumb_ctl ul.nav_ul").children('li:last').remove();
    } else {
      $(".thumb_ctl ul.nav_ul").remove();
      $(".thumb_ctl span").remove();
    }
    var pos_flg = 2;
    $(".thumb_ctl .next").on('click', function() {
      prev_btn();
    });
    $(".thumb_ctl .prev").on('click', function() {
      next_btn();
    });

    function prev_btn() {
      if (pos_flg < total_cont) {
        $(".thumb_container_track").animate({
          "left": "-=150px"
        });
        $(".thumb_ctl ul.nav_ul li.active").removeClass('active').next().addClass('active');
        pos_flg++;
      }
      return false;
    };

    function next_btn() {
      if (pos_flg > 2) {
        $(".thumb_container_track").animate({
          "left": "+=150px"
        });
        $(".thumb_ctl ul.nav_ul li.active").removeClass('active').prev().addClass('active');
        pos_flg--;
      }
      return false;
    };
  }

  $('input.kanri').on('change', function() {
    var prop = $(this).prop('checked');
    if (prop) {
      var old_price = $(this).parent('div').next().text();
      old_price = parseInt(old_price.split(',').join('').trim());
      var add_price = $(this).parent('div').data('kanri');
      var new_price = old_price + add_price;
      $(this).parent().next().text(new_price.toLocaleString() + '円');
    } else {
      var old_price = $(this).parent('div').next().text();
      old_price = parseInt(old_price.split(',').join('').trim());
      var add_price = $(this).parent('div').data('kanri');
      var new_price = old_price - add_price;
      $(this).parent().next().text(new_price.toLocaleString() + '円');
    }
  });

  $('.search-box input[type="checkbox"],.search-box select').on('change', function(e) {
    e.preventDefault();
    submitForm();
  });

  // 郵便番号を半角数字のみにする
  $(".p-postal-code").blur(function() {
    changeZen($(this));
  });

  changeZen = function(ele) {
    let val = ele.val();
    val = val.replace(/ー|-|−/g, '');
    let han = val.replace(/[Ａ-Ｚａ-ｚ０-９－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 65248)
    });
    $(ele).val(han);
  }

  $('.button-more').on('touchstart', function() {
    $(this).addClass('hover');
  });

  $('.button-more').on('touchend', function() {
    $(this).removeClass('hover');
  });

  if ($('.product-post').length) {
    $('#navi .thumb_container_track img').each(function() {
      var img_height = $(this).height();
      var img_width = $(this).width();
      var img = new Image();
      img.src = $(this).attr('src');
      var _width = img.width;
      if ((img_width / img_height) >= 1) {
        $(this).css("object-fit", "cover");
      } else {
        $(this).css("object-fit", "contain");
      }
      $(this).css("width", "100%");
    });

    $('.thumb_nav_ext img').each(function() {
      var img_height = $(this).height();
      var img_width = $(this).width();
      var img = new Image();
      img.src = $(this).attr('src');
      var _width = img.width;
      if ((img_width / img_height) >= 1) {
        $(this).css("object-fit", "cover");
      } else {
        $(this).css("object-fit", "contain");
      }
      $(this).css("width", "100%");
    });
  }

  if ($('.single-topics').length || $('.column-contents').length) {
    // iframeをvideoで囲む
    const contMainElement = document.querySelector('.cont_main');
    const iframeElements = contMainElement.querySelectorAll('iframe');

    if (iframeElements) {
      iframeElements.forEach((iframeElement) => {
        const videoWrapperElement = document.createElement('div');
        videoWrapperElement.classList.add('video');
        iframeElement.parentNode.insertBefore(videoWrapperElement, iframeElement);
        videoWrapperElement.appendChild(iframeElement);
      });
    }
  }
});